import { Route, Routes } from "react-router-dom";
import AdminRoute from "./components/AdminRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import DepositPage from "./pages/deposit";
import SettingsPage from "./pages/settings";
import DetailPage from "./pages/detail";
import DownloadPage from "./pages/download";
import GuidePage from "./pages/HowToUse";
import IonizableTablePage from "./pages/ionTable";
import LoginPage from "./pages/login";
import Main from "./pages/main";
import Overview from "./pages/overview";
import ProfilePage from "./pages/profile";
import Reference from "./pages/reference";
import RegisterPage from "./pages/register";
import StructureSearch from "./pages/StructureSearch";
import TextSearch from "./pages/TextSearch";
const isBeta = process.env.REACT_APP_ENABLE_ADMIN === "True";

// Wrap content requiring login if isBeta is true
const BetaProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  return isBeta ? <ProtectedRoute>{children}</ProtectedRoute> : children;
};

const Content = () => {

  return (
    <Routes>
      <Route path="/" element={<BetaProtectedRoute><Main /></BetaProtectedRoute>} />
      <Route path="/search/text" element={<BetaProtectedRoute><TextSearch /></BetaProtectedRoute>} />
      <Route path="/search/structure" element={<BetaProtectedRoute><StructureSearch /></BetaProtectedRoute>} />
      <Route path="/ionizable" element={<BetaProtectedRoute><IonizableTablePage /></BetaProtectedRoute>} />
      <Route path="/reference" element={<BetaProtectedRoute><Reference /></BetaProtectedRoute>} />
      <Route path="/detail/:pk" element={<BetaProtectedRoute><DetailPage /></BetaProtectedRoute>} />
      <Route path="/overview" element={<BetaProtectedRoute><Overview /></BetaProtectedRoute>} />
      <Route path="/downloads" element={<BetaProtectedRoute><DownloadPage /></BetaProtectedRoute>} />
      <Route path="/guide" element={<BetaProtectedRoute><GuidePage /></BetaProtectedRoute>} />
      
      {isBeta && (
        <>
          <Route
            path="/deposit"
            element={
              <ProtectedRoute>
                <DepositPage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <SettingsPage />
              </AdminRoute>
            }
          />
        </>
      )}
    </Routes>
  );
};

export default Content;
